window.am = window.am || {};

window.am.requiredNumber = new function () {
    var that = this;
    that.validationName = 'number';

    that.init = function () {
        if (!$.validator) {
            return;
        }

        var adapters = $.validator.unobtrusive.adapters;

        $.validator.addMethod(
            that.validationName,
            function (value, element, params) {
                value = value.replace(/\s/gm, '');
                //the validation should only check for numbers if the value is not empty
                if (/^\d+$/.test(value) || !value) {
                    return true;
                }
                return false;
            },
            'Only numbers are allowed.');

        adapters.add(that.validationName, function (options) {
            options.rules['number'] = true;
            if (options.message) {
                options.messages['number'] = options.message;
            }
        });
    }
}

window.am.requiredNumber.init();